var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 0C0.447715 0 0 0.447715 0 1V11C0 11.2654 0.105517 11.5199 0.293305 11.7075L8.8825 20.2867L8.88271 20.2869C9.16129 20.5658 9.49208 20.787 9.85618 20.9379C10.2204 21.0889 10.6108 21.1666 11.005 21.1666C11.3992 21.1666 11.7896 21.0889 12.1538 20.9379C12.5178 20.787 12.8486 20.5659 13.1271 20.2871L13.1275 20.2867L20.2971 13.1171L19.59 12.41L20.2992 13.115C20.858 12.5529 21.1716 11.7926 21.1716 11C21.1716 10.2074 20.858 9.44709 20.2992 8.885L20.2971 8.88289L11.7071 0.292893C11.5196 0.105357 11.2652 0 11 0H1ZM18.8817 11.7041L18.8808 11.705L11.7129 18.8729L11.7125 18.8733C11.6196 18.9663 11.5093 19.04 11.3879 19.0903C11.2665 19.1407 11.1364 19.1666 11.005 19.1666C10.8736 19.1666 10.7435 19.1407 10.6221 19.0903C10.5007 19.04 10.3904 18.9663 10.2975 18.8733L10.2967 18.8725L2 10.5854V2H10.5858L18.8808 10.295L18.8817 10.2959C19.0674 10.4832 19.1716 10.7362 19.1716 11C19.1716 11.2638 19.0674 11.5168 18.8817 11.7041ZM6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7H6.01C6.56228 7 7.01 6.55228 7.01 6C7.01 5.44772 6.56228 5 6.01 5H6Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.a0156baa.svg";
export { ForwardRef as ReactComponent };